import { Datepicker } from 'vanillajs-datepicker';
import './calendar.scss';

export class Calendar {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEventHandlers();
	}

	initData(props = {}) {
		this.data = {};
		this.setter(props);
		this.setCssLink();
	}

	setCssLink() {
		if (!document.getElementById('engt-calendar-css')) {
			const csslink = document.createElement('link');
			csslink.href = 'https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.2.0/dist/css/datepicker.min.css';
			csslink.type = 'text/css';
			csslink.id = 'engt-calendar-css';
			csslink.rel = 'stylesheet';
			document.getElementsByTagName('head')[0].appendChild(csslink);
		}
	}

	initWrapper() {
		const { id, label, errorId } = this.data;
		const wrapper = document.createElement('div');
		const pickerWrapper = document.createElement('div');
		const labelElem = document.createElement('div');
		const errorMsg = document.createElement('error-msg');
		if (label) {
			labelElem.classList.add('engt-form-label', 'engt-date-label');
			labelElem.innerHTML = label;
			wrapper.appendChild(labelElem);
		}
		pickerWrapper.setAttribute('data-field-role', 'input');
		pickerWrapper.setAttribute('data-selected-date', new Date().toLocaleDateString());
		errorMsg.id = errorId || `engt-error-${id}`;
		errorMsg.classList.add('engt-error');
		errorMsg.style.marginTop = '4px';
		pickerWrapper.id = id;
		this.datepicker = new Datepicker(pickerWrapper, {
			maxView: 2,
		});
		wrapper.appendChild(pickerWrapper);
		wrapper.appendChild(errorMsg);
		this.html = wrapper;
	}

	onClick() {
		const selectedDate = this.datepicker.getDate('dd/mm/yyyy');
		const picker = document.getElementById(this.data.id);
		picker?.setAttribute('data-selected-date', selectedDate);
	}

	initEventHandlers() {
		const self = this;
		this.html.addEventListener('click', self.onClick.bind(this));
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
